import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/layouts/DashboardLayout';

// Import vendor page components
import VendorDashboard from './dashboard';
import VendorBookings from './bookings';
import VendorAnalytics from './analytics';
import VendorSettings from './settings';
import VendorShops from './shops';
import VendorShopManagement from './shops/shopManagements';

const VendorLayout = () => {
  return (
    <DashboardLayout>
      <Routes>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<VendorDashboard />} />
        <Route path="bookings" element={<VendorBookings />} />
        <Route path="shops" element={<VendorShops />} />
        <Route path="shops/:shopId" element={<VendorShopManagement />} />
        <Route path="analytics" element={<VendorAnalytics />} />
        <Route path="settings" element={<VendorSettings />} />
      </Routes>
    </DashboardLayout>
  );
};

export default VendorLayout;
